/**
 * 员工管理api
 */
export default {
  
  employeeInfoSelect:'/employeeInfo/select',//查询员工（分页）
  positionInfoSelect:'/positionInfo/select',//查询职位
  departmentInfoSelect:'/departmentInfo/select',//查询部门
  selectParentDepartment:'/departmentInfo/selectParentDepartment',//查询上级部门下拉框


  
}
